import { FunctionalComponent, h } from 'preact';
import styled from 'styled-components';
import { createWithStyle } from '../utils';
import HostedInputContainer from '../HostedInputContainer';

const withInputStyle = createWithStyle((style) => style?.input);

const InputContainer = styled.div`
  flex: 1;
`;

const StyledInputContainer = styled(HostedInputContainer)`
  ${(p) =>
    p.hasPaddingLeft &&
    withInputStyle((style) => ({
      paddingLeft: style?.base?.paddingHorizontal,
    }))}

  ${(p) =>
    p.hasPaddingRight &&
    withInputStyle((style) => ({
      paddingRight: style?.base?.paddingHorizontal,
    }))}

 
    & ${InputContainer} {
    ${(p) =>
      // A bit hacky: we can't disable the paddingHorizontal of the hosted input
      // but we just need 10px between the icon and the input field
      p.hasPaddingLeft &&
      withInputStyle((style) => ({
        marginLeft: -(style?.base?.paddingHorizontal ?? 0) + 10,
      }))}

    ${(p) =>
      // A bit hacky: we can't disable the paddingHorizontal of the hosted input
      // but we just need 10px between the icon and the input field
      p.hasPaddingRight &&
      withInputStyle((style) => ({
        marginRight: -(style?.base?.paddingHorizontal ?? 0) + 10,
      }))}
  }
`;

const Container = styled.div`
  display: flex;
  height: 100%;
`;

type Props = {
  inputId?: string;
  focused?: boolean;
  hasErrors?: boolean;
  beforeInput?: any;
  afterInput?: any;
};

const HostedInput: FunctionalComponent<Props> = ({
  inputId,
  focused = false,
  hasErrors = false,
  beforeInput,
  afterInput,
}) => {
  return (
    <StyledInputContainer
      focused={focused}
      hasErrors={hasErrors}
      hasPaddingLeft={!!beforeInput}
      hasPaddingRight={!!afterInput}
    >
      <Container>
        {beforeInput}
        <InputContainer
          className='PrimerCheckout__formInput PrimerCheckout__formInput--hosted'
          id={inputId}
          data-testId='HostedInput/Field'
        ></InputContainer>
        {afterInput}
      </Container>
    </StyledInputContainer>
  );
};

export default HostedInput;
